import { foodImage } from "@/assets";

const Template1 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || foodImage;
  const title = previewData?.title || (isStrictPreview ? "No provide" : "VOUCHER");
  const customerName =
    previewData?.customerName || (isStrictPreview ? "No provide" : "Royel Tanduri");
  const code = previewData?.code || (isStrictPreview ? "No provide" : "32154232");
  const paymentText = previewData?.paymentMethods?.length
    ? previewData.paymentMethods.map(m => m.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(", ")
    : isStrictPreview
      ? "No provide"
      : "Cash Only";
  const orderTypeText = previewData?.orderTypes?.length
    ? `For ${previewData.orderTypes.map(t => t.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(" / ")} only`
    : isStrictPreview
      ? "No provide"
      : "For dine in only ( not for Takeaway or Delivery )";
  const isConjunction =
    previewData?.isConjunction !== null && previewData?.isConjunction !== undefined
      ? Boolean(previewData?.isConjunction)
      : previewData?.is_conjunction !== null && previewData?.is_conjunction !== undefined
        ? Boolean(previewData?.is_conjunction)
        : !isStrictPreview;
  const conjunctionText = isConjunction ? "Not conjunction with any other offer" : null;
  const expiryDate = previewData?.expiryDate || (isStrictPreview ? "No provide" : "12/05/2026");
  const templateNote =
    previewData?.templateNote ||
    previewData?.template_note ||
    (previewData?.message && previewData.message !== title ? previewData.message : null);
  const voucherItems = previewData
    ? (previewData.voucherItems || [])
    : (isStrictPreview ? [] : [{ menu_item: { name: "Coca-Cola" }, variant: { name: "Medium" } }]);

  return (
    <div className="flex items-center justify-center p-4">
      <div
        data-export-capture="voucher-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex justify-center items-center"
      >
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        ></div>
        <div className="relative z-10 w-[68%] h-full bg-white/90 flex flex-col items-center justify-center p-6 text-black">
          {/* Header Section */}
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold uppercase tracking-tight leading-none mb-1">
              {title}
            </h1>
            <p className="text-lg font-serif italic text-gray-700">
              {customerName}
            </p>
            <p className="text-lg font-medium mt-1">Code: {code}</p>
            {templateNote ? (
              <p className="text-sm font-medium italic text-gray-800 mt-1">
                &quot;{templateNote}&quot;
              </p>
            ) : null}
          </div>
          {((paymentText && paymentText !== "Not provided" && paymentText !== "No provide") ||
            (orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide") ||
            conjunctionText ||
            (expiryDate && expiryDate !== "N/A" && expiryDate !== "Not provided" && expiryDate !== "No provide") ||
            (voucherItems && voucherItems.length > 0)) && (
            <div className="w-full text-left self-start mt-2">
              <div className="text-[11px] leading-tight text-gray-800">
                <p className="mb-1 uppercase tracking-tight font-medium">
                  -Terms & Conditions-
                </p>
                <ul className="list-disc list-inside space-y-0.5 ml-1">
                  {paymentText && paymentText !== "Not provided" && paymentText !== "No provide" && <li>{paymentText}</li>}
                  {orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide" && <li>{orderTypeText}</li>}
                  {conjunctionText && <li>{conjunctionText}</li>}
                  {expiryDate && expiryDate !== "N/A" && expiryDate !== "Not provided" && expiryDate !== "No provide" && <li>Exp. Date: {expiryDate}</li>}
                  {voucherItems.map((item, index) => (
                    <li key={index}>
                      Item: {item?.menu_item?.name || item?.name || ""}
                      {item?.variant?.name ? ` (${item.variant.name})` : item?.variant_name ? ` (${item.variant_name})` : ""}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Template1;
